import React from 'react';

//import Dropzone from 'react-dropzone';
import Select from 'react-select';

import {
    Alert , 
} from 'reactstrap';


/*

import {
    Alert , UncontrolledAlert ,
    Row, Col,
} from 'reactstrap';

import {
    Collapse, Navbar, NavbarBrand, Nav, NavItem,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Container, InputGroup, InputGroupAddon, Input
} from 'reactstrap';

import {
    Messages, Notifications
} from 'components';*/

//import dashboardRoutes from 'routes/general.jsx';

//import { messages } from 'variables/topbar.jsx';
//import { notifications } from 'variables/topbar.jsx';



//var IMGDIR = process.env.REACT_APP_IMGDIR;
const layouttype = [
  { label: "Only Image (no GTP)", value: 1 },
  { label: "Two Columns (GTP , Product Image & Wire Diagram)", value: 2 },
  { label: "Two Columns (GTP & Product Image ONLY)", value: 3 },
  
];

const divstyle={
  "paddingTop":"75px",
  
}

class ProdutForm extends React.Component{
api;
constructor(props){
    super(props);
      //this.state={inputFields:[{gtpoption: "", gtpvalue: "",prohead:false }]};
     
      this.state = { 
           alertvisible:false,
           alesrtsuccessmess:"",
           curproductid:'',
           dupproudctid:'',
           topprfile: null,
           botprfile: null,
           testcert: null,
           disabled1: true,
           prtitle: "",
           prabbr: "",
           productlist:[],
           dupproductlist:[],
           layout:{label: "Two Columns (GTP , Product Image & Wire Diagram)", value: 2 },
           topfile:"",
           bottomfile:"",
           testfile:"",
           topimageurl:"",
           bottomimageurl:"",
           testcetificateurl:"",
           

        }
        this.baseState = this.state;
        this.onDismiss = this.onDismiss.bind(this);
        this.handleSubmit  = this.handleSubmit.bind(this);
        this.handleInputChange  = this.handleInputChange.bind(this);
        this.getProductData   = this.getProductData.bind(this);
    }
 onDismiss() {
    this.setState({ alertvisible: false });
  }

componentDidMount() {
        this.getProductData();
        //console.log(this.state.layout);
      }

getProductData = (pro) => {
      //console.log("get data calling="+new Date().toLocaleString());
       this.api=window.$apibase+"/api/prodtlist";
      if(pro)
      {

        this.api=window.$apibase+"/api/prodtlist?prname="+pro;
      }
      else
      {
          this.api=window.$apibase+"/api/prodtlist";
      }
        fetch(this.api)
          .then(response => response.json())
          .then(data => {
          //console.log(data);
            this.setState({ productlist: [...data] });

                     
             
            

            
           
            this.setState({ dupproductlist: [...data] });


              
            
            
          });




          
}

getProductDetails=(pro,ptype)=>{
  
      if(pro)
      {

        this.api=window.$apibase+"/api/prodtdetails?prname="+pro;
      }
      else
      {
          this.api=window.$apibase+"/api/prodtdetails";
      }
        fetch(this.api)
          .then(response => response.json())
          .then(data => {
              data.map((item, itemIndex) => {
              //console.log(item.top_image);
              this.state.topimageurl=item.top_image;

              if(ptype==="product")
              {
                  if(item.title)
                    this.setState({ prtitle:item.title});
                  else
                  {
                     this.setState({ prtitle:""});
                  }
                  if(item.abbrevation)
                    this.setState({ prabbr:item.abbrevation});
                  else
                    this.setState({ prabbr:""}); 
              }      

                  if(item.layout)
                  {
                    let layoutfilter=layouttype.filter(function(task, index) {
                                  if(task.value == item.layout)
                                  {
                                      
                                       return task;
                                  }

                                  //console.log("task value"+task.value+"  "+item.layout);
                      });

                      this.setState({layout: layoutfilter});
                       //console.log(layoutfilter);
                      //console.log("layout type"+this.state.layout);
                  }

                  if(item.top_image)
                    this.setState({ topimageurl:item.top_image});
                  else
                    this.setState({ topimageurl:""});
                  if(item.bottom_image)
                    this.setState({ bottomimageurl:item.bottom_image});
                  else
                    this.setState({ bottomimageurl:""});
                  if(item.test_certificate)
                    this.setState({ testcetificateurl:item.test_certificate});
                  else
                    this.setState({ testcetificateurl:""});

                     this.forceUpdate();
              })
              
          });


}

handleInputChange = (event) => {
    if (event.target.name === "ptitle") {
      this.setState({
          prtitle: event.target.value
        });
    }
    else if(event.target.name === "pabb"){
    this.setState({
        prabbr: event.target.value
        });
    }

}



selecteChange=(opt,ptype)=>{



  //console.log(opt.label+"  "+opt.value);

  if(ptype==="duplicate")
  {
      this.setState({
          dupproudctid:opt.value
      });
  }
  else if(ptype==="layout")
  {
      this.setState({
          layout:opt
      });
      //console.log(this.state.layout.value);
  }
  else
  {
      this.setState({
          curproductid:opt.value

      });
  }


  if(ptype!="layout" && (opt.value && opt.value>0))
    this.getProductDetails(opt.value,ptype);
  else
   {
      
        if(ptype==="product")
        {
          this.setState(this.baseState);  
            this.state.topfile="";
            this.state.bottomfile=null;
            this.state.testfile=null;
            this.getProductData();
        }
      

   }

 //  console.log("current product="+this.state.curproductid);
//console.log("Dupliace from product="+this.state.dupproudctid);
}

handleSubmit = e => {
    e.preventDefault();
    //console.log("inputFields", this.state.inputFields);

    const formData = new FormData(); 

    if(this.state.curproductid>0)
    {
        formData.append( 
        "productid", 
        this.state.curproductid, 
       ); 
    }

    if(this.state.dupproudctid>0)
    {
        formData.append( 
        "duplproductid", 
        this.state.dupproudctid, 
       ); 
    }

    formData.append( 
        "prtitle", 
        this.state.prtitle, 
       ); 
    formData.append( 
        "prabbr", 
        this.state.prabbr, 
     ); 
     if(this.state.layout.value!== undefined)
     {
        formData.append( 
           "layout", 
           this.state.layout.value, 
        ); 
      }
      else
      {
          formData.append( 
           "layout", 
           2 
        ); 
      }

     if(this.state.topprfile )
     {
        formData.append( 
          "topproduct", 
          this.state.topprfile, 
          this.state.topprfile.name 
      ); 
    }
    if(this.state.botprfile)
     {
    formData.append( 
        "bottomproduct", 
        this.state.botprfile, 
        this.state.botprfile.name 
      );
      }
    if(this.state.testcert )
     { 
    formData.append( 
        "testcertificate", 
        this.state.testcert, 
        this.state.testcert.name 
      ); 
     }
    //console.log(formData);
     //console.log(this.state.topprfile.name);

      fetch(window.$apibase+'/api/product', {
        method: 'POST',
        // We convert the React state to JSON and send it as the POST body
        body: formData,
        //headers: { 'Content-Type': 'application/json' },
        //body: JSON.stringify(this.state)
      }).then(function(response) {

        //console.log(response)
          if(response.status === 200){
            // alert("saved successfully");
              
          }

           // console.log(this.state.topfile);
        return response.json();
      }).then((data) => {

          //this.setState({topfile:""});


            if(data.result.label!='')
            {
                this.setState({alesrtsuccessmess:data.result.label+" saved sucessfully",alertvisible:true});
            }
            else
              this.setState({alesrtsuccessmess:"saved sucessfully",alertvisible:true});
          this.setState(prevState => {

                if(data.result.value!='')
                {
                  if(prevState.productlist.some(pl=>pl.value===data.result.value))
                  {
                       return {
                     productlist: [...prevState.productlist]
                     }
                  }
                  else
                  {
                      return {
                     productlist: [...prevState.productlist, data.result]
                     }
                      
                  }
                }
                else
                {
                    return {
                     productlist: [...prevState.productlist]
                     }
                }
          });

          this.props.onChange(data.result);
      });
       // console.log(response.data);
          this.setState(this.baseState);  
            this.state.topfile="";
            this.state.bottomfile=null;
            this.state.testfile=null;
        this.getProductData();
          this.forceUpdate();
  };

  onFiletopChange=(event)=>  {
        this.setState({
          topprfile:event.target.files[0],
          topfile:event.target.value,
          
        });
      };   
  
  onFilebottomChange=(event)=>  {
        this.setState({
          botprfile:event.target.files[0],
           bottomfile:event.target.value,
        });
      };

  onFiletestcert=(event)=>  {
        this.setState({
          testcert:event.target.files[0],
          testfile:event.target.value
        });
      };       
    
    render() {
    return (
    <section className="box ">
       <header className="panel_header"><h2 className="title float-left">Product</h2></header>
    <div className="content-body">
    <div className="col-md-12">
      <div className="form-row">
      <div className="col-md-9">
      <form onSubmit={this.handleSubmit.bind(this)}>
        <h1></h1>
          <Alert color="success" isOpen={this.state.alertvisible} toggle={this.onDismiss}>
              {this.state.alesrtsuccessmess}.
          </Alert>
         <div className="content-body">
          <div className="form-row">
        <div className="form-group col-sm-6">
           <label htmlFor="product">Product</label>
            <Select name="product"  options={this.state.productlist}  onChange={opt => this.selecteChange(opt,"product")}/>
        </div>
        <div className="form-group col-sm-6 ">
           <label htmlFor="product">Duplicate from (Only Images)</label>
            <Select name="dupproduct" options={this.state.dupproductlist}  onChange={opt => this.selecteChange(opt,"duplicate")}/>
        </div>
        </div>
        <div className="form-row">
          <div className="form-group col-sm-6">
             <label htmlFor="ptitle">Product Title</label>
            <input className="form-control" name="ptitle" id="ptitle"
            type="text"
            value={this.state.prtitle}
            onChange={event => this.handleInputChange(event)}
              />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-sm-6">
             <label htmlFor="ptitle">Product Abbreviation</label>
            <input className="form-control" name="pabb" id="pabb"
            type="text"
            value={this.state.prabbr}
            onChange={event => this.handleInputChange(event)}
              />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-sm-6">
              <label htmlFor="layout">PDF Layout</label>
              <Select name="layout"  options={layouttype}  value={this.state.layout} onChange={opt => this.selecteChange(opt,"layout")}/>
          </div>
        </div>
        <div className="form-group col-sm-8">
           <label  className="col-sm-3" htmlFor="pimg1">Product Image1</label>
          <input type="file"  value={this.state.topfile} name="pimg1" onChange={this.onFiletopChange} /> 
        </div>
        <div className="form-group col-sm-8">
           <label  className="col-sm-3" htmlFor="pimg2">Product Image2 (WireFrame)</label>
          <input type="file"  value={this.state.bottomfile} name="pimg2" onChange={this.onFilebottomChange} /> 
        </div>
        <div className="form-group col-sm-8">
           <label  className="col-sm-3" htmlFor="pcert">Product Test Certificate</label>
          <input type="file" value={this.state.testfile}  name="pcert" onChange={this.onFiletestcert} /> 
        </div>
        <div className="submit-button">
          <button
            className="btn btn-primary mr-2"
            type="submit"
            onSubmit={this.handleSubmit}
          >
            Save Product
          </button>
        </div>
        </div>
      </form>
      </div>
      <div className="col-md-3" style={divstyle}>
          <form>
            <div className="content-body">
          
             <div className="form-group col-sm-8">
                <label  htmlFor="imgtop">Product Image1 : </label>
                 <img name="imgtop" key={Date.now()} src={this.state.topimageurl}/>
             </div>
             <div className="form-group col-sm-8">
                <label  htmlFor="botimg">Product Image2 (WireFrame): </label>
                 <img name="botimg" key={Date.now()} src={this.state.bottomimageurl}/>
    
             </div>
             <div className="form-group col-sm-8">
                 <label  htmlFor="testcert">Test Certificate : </label>
                 <img name="testcert" key={Date.now()} src={this.state.testcetificateurl}/>
    
             </div>
            </div>
          </form>
      </div>
      </div>
    </div>
    </div>
    </section>
    );
  }
}

export default ProdutForm;